module.exports = {"id":"202911","name":"Rodrigo Mora","rating":"73","photo":"./data/images/photos/0/202911.png","club":{"name":"River Plate","logo":"./data/images/clubs/RiverPlate.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RodrigoMora0.json
// module id = 3672
// module chunks = 0